import React from 'react';

const ArrowLeftIcon = () => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M20.25 12L3.75 12'
				stroke='#3D3D8F'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M10.5 18.75L3.75 12L10.5 5.25'
				stroke='#3D3D8F'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowLeftIcon;
